import XIcon from "@mui/icons-material/Close"
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material"

import { DialogProps } from "@/dialogs"
import useDeleteEvent from "@/hooks/api/events/useDeleteEvent"

interface ConfirmDeleteEventDialogProps extends DialogProps {
  eventId: number
}

function ConfirmDeleteEventDialog({
  isOpen,
  closeDialog,
  eventId,
}: ConfirmDeleteEventDialogProps) {
  const { mutateAsync: deleteEvent } = useDeleteEvent()
  function handleClose() {
    closeDialog()
  }

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        minWidth={"500px"}
        pl={3}
        pr={1}
        py={1}
        sx={{
          backgroundColor: "primary.main",
          color: "primary.contrastText",
        }}
      >
        <Typography>Delete Event</Typography>
        <Box>
          <IconButton color="inherit" onClick={handleClose}>
            <XIcon />
          </IconButton>
        </Box>
      </Stack>
      <DialogContent
        sx={{
          py: 2,
        }}
      >
        <Typography>Are you sure you want to delete this event?</Typography>
        <Stack direction="row" justifyContent="flex-end" spacing={2} mt={5}>
          <Button variant="text" color="inherit" onClick={closeDialog}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={() => {
              deleteEvent(eventId)
              closeDialog()
            }}
          >
            Delete
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmDeleteEventDialog
